module.exports = __webpack_public_path__ + "static/img/5.dc29f99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Personas/5.png
// module id = Saiv
// module chunks = 0